module.exports = __webpack_public_path__ + "img/thumbnail-list-img-feetscare.d855abc5.png";